import React, { useContext, useEffect, useMemo } from 'react'
import { CarouselPage, HpSoftwarePage } from '../pages/LazyPages'
import { ConfigContext } from '../store/ConfigContext'
import { Instructions } from '../store/Constants'

const HpSoftwareTrilliumPaasRoute = ({ footer }) => {
  const setNextVisible = footer?.setNextVisible

  useEffect(() => {
    if (!setNextVisible) {
      return undefined
    }

    setNextVisible(false)

    return () => {
      setNextVisible(null)
    }
  }, [setNextVisible])

  return <HpSoftwarePage />
}

const resolveHpSoftwareTrilliumRoute = (paas, footer) => {
  if (paas === null) {
    return null
  }

  if (paas) {
    return <HpSoftwareTrilliumPaasRoute footer={footer} />
  }

  return (
    <CarouselPage
      key={Instructions.hp_software}
      instruction={Instructions.hp_software}
    />
  )
}

export const HpSoftwareTrilliumRoute = () => {
  const { paas, footer } = useContext(ConfigContext)

  return useMemo(
    () => resolveHpSoftwareTrilliumRoute(paas, footer),
    [paas, footer]
  )
}

export default resolveHpSoftwareTrilliumRoute
